module.exports = __webpack_public_path__ + "static/media/hint.30367a6b.svg";